module.exports = __webpack_public_path__ + "static/img/图层 509.3f6fce9f.png";